import {
  NullableSize,
  OuiBoxComponent,
  OuiExpandComponent,
  OuiRowComponent,
  OuiStackComponent,
  OuiSymbolComponent,
  OuiTextComponent,
  ThemeService,
} from '@aiz-gl/omni-ui';
import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { css } from '@emotion/css';

import { BreakpointService } from '@aiz-gl/omni-ui';
import { breakpoint } from '../../app.breakpoints';
import { NavigationMenuService } from '../../services/navigation-menu/navigation-menu.service';

@Component({
  selector: 'app-navigation-menu',
  standalone: true,
  imports: [
    OuiBoxComponent,
    NgTemplateOutlet,
    OuiRowComponent,
    RouterLink,
    RouterLinkActive,
    OuiSymbolComponent,
    OuiTextComponent,
    OuiExpandComponent,
    OuiStackComponent,
  ],
  templateUrl: './navigation-menu.component.html',
})
export class NavigationMenuComponent {
  theme = inject(ThemeService);
  menu = inject(NavigationMenuService);
  activePath = signal<string>('');

  breakpoints = inject(BreakpointService);

  paddingVertical = this.breakpoints.signal<NullableSize>(
    [breakpoint.lowResMonitor('xs')],
    'sm',
  );

  menuItemClass = computed(() =>
    css({
      cursor: 'pointer',
      transition: 'all ease-in-out 350ms',

      '&.active-link': {
        cursor: 'unset',
      },

      '&.active-non-parent-link div:first-of-type': {
        ...this.theme.colorPair('tertiary'),
      },

      '&:hover:not(.active-link)': {
        backgroundColor: this.theme.colors()['scrim'],
      },
    }),
  );

  submenuItemClass = computed(() =>
    css({
      '& div:first-of-type': {
        cursor: 'pointer',
        transition: 'all ease-in-out 350ms',
        ...this.theme.radius('xs'),
      },

      '&.active-link div:first-of-type': {
        ...this.theme.colorPair('tertiary'),
        cursor: 'unset',
      },

      '&:hover:not(.active-link) div:first-of-type': {
        backgroundColor: this.theme.colors()['scrim'],
      },
    }),
  );

  approvalIndicatorDotClass = css({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#e61b1b',
    display: 'inline-block',
  });

  badgeCountClass = css({
    fontSize: '11px',
    lineHeight: 1,
    fontWeight: 600,
  });

  handleActiveRoute(active: boolean, path: string) {
    if (active) {
      this.activePath.set(path);
    }
  }
}
